export const DtiRecommendationBase = {
  debtResolutionCardLink: '',
  personalLoansCardLink: '',
  homeLoansCardLink: '',
  lowRatioLinkHref: '',
  mediumRatioLinkHref: '',
  highRatioLinkHref: '',
  onDebtResolutionClick: undefined,
  onPersonalLoansClick: undefined,
  onHomeLoansClick: undefined,
  onGoodAppClick: undefined,
  onMoloAppClick: undefined,
  onLowRatioLinkClick: undefined,
  onMediumRatioLinkClick: undefined,
  onHighRatioLinkClick: undefined,
}
